/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ProgressBar/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function ProgressBar({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentCard/Summary/Content/Content/Progress/Content/Content/ProgressBar",
  backgroundColor
  
}) {
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtColorsNeutral300 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.300'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let treatmentProgressPercentageValueData = fromData.useDataFormat({ viewPath,
context: 'treatment_progress',
path: 'percentage',
format: fromFormat.percentage,
})
  return (<React.Fragment
>
<div
  data-testid="ProgressBar.Horizontal"
  data-view-path={viewPath}
 style={{'--h-1-Z1L134q': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bc-2-Z1L134q': dtColorsNeutral300,'--mt-3-Z1L134q': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--mb-4-Z1L134q': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--bblr-5-Z1L134q': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--bbrr-6-Z1L134q': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--btlr-7-Z1L134q': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--btrr-8-Z1L134q': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="ProgressBar.Horizontal:1"
  data-view-path={viewPath}
 style={{'--w-9-Z1L134q': typeof treatmentProgressPercentageValueData === 'number' ? `${treatmentProgressPercentageValueData}px` : treatmentProgressPercentageValueData,'--bc-2-Z1L134q': backgroundColor}}
 className={`views-block ${styles.Horizontal1}`}
/>
</div>
{children}
</React.Fragment>)
}